var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-spinner-wrapper"},[_c('div',{staticClass:"row flex-items-xs-center"},[(_vm.loading)?_c('sdx-loading-spinner',{staticClass:"loader-spinner",attrs:{"size":"large","sr-hint":"Loading. Please wait."}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }